import React from 'react';
import { Navigate } from 'react-router-dom';
import authService from './loginService';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const isAuthenticated = authService.isAuthenticated();
  const currentUser = authService.getCurrentUser();

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Si se especifican roles permitidos, verificar que el usuario tenga uno de esos roles
  if (allowedRoles.length > 0 && currentUser) {
    const hasPermission = allowedRoles.includes(currentUser.role);
    if (!hasPermission) {
      // Redirigir según el rol del usuario
      if (currentUser.role === 'user') {
        return <Navigate to="/user-dashboard" replace />;
      } else {
        return <Navigate to="/dashboard" replace />;
      }
    }
  }

  return children;
};

export default ProtectedRoute;